export enum OilStoreTypeQueryKeys {
  GET_OIL_STORE_TYPES = 'GET_OIL_STORE_TYPES',
  GET_OIL_STORE_TYPE_DETAIL = 'GET_OIL_STORE_TYPE_DETAIL',
}
